import { DateTime } from "luxon";
import { CustomFields } from "../models/core";

export function getNewestDate(dates: (DateTime | null)[]) {
    const dateObjects = dates?.map(date => date ? date.toUnixInteger() : 0) || [];
    const idx = dateObjects.indexOf(Math.max(...dateObjects));
    return idx != -1 ? dates[idx] : undefined;
}

export function findLastContactDate(fields: CustomFields) {
    const dateFields = ['Call Attempt 1','Call Attempt 2','Call Attempt 3','Call Attempt 4','Call Attempt 5','Call Attempt 6','Date of Text Attempt', 'Date of Email Attempt', 'Date of Mail Attempt'];
    const dateArray:DateTime[] = []
    dateFields.forEach(key => {
        const val = fields[key];
        if(val != undefined) {
            if(val instanceof Date) {
                const dtCheck = DateTime.fromJSDate(val);
                dtCheck != undefined && dtCheck != null && dateArray.push(dtCheck);
            } else if(typeof val === 'string') {
                const dtCheck = DateTime.fromISO(val);
                dtCheck != undefined && dtCheck != null && dateArray.push(dtCheck);
            }
        }
    });

    return getNewestDate(dateArray);
}

export function formatDates(fields: CustomFields): CustomFields {
    return Object.fromEntries(Object.entries(fields).map(([k, v]) => [
        k,
        v instanceof Date
            ? (DateTime.fromJSDate(v).toISO({
                suppressMilliseconds: true, suppressSeconds: true, includeOffset: false
            }) || '')
            : v
    ]))
}